import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { UPDATE_UNIT, UPDATE_UNIT_FAIL, UPDATE_UNIT_SUCCESS, UpdateUnitActionType } from '../redux/unitsReducer'

function* UpdateUnitFlow(action: UpdateUnitActionType): Generator<any, void, any> {
  try {
    const response = yield call(apiCall, {
      endpoint: `/tutors/units/${action.payload.id}`,
      method: 'PUT',
      params: { name: action.payload.name, description: action.payload.description, image: action.payload.image }
    })
    yield put(UPDATE_UNIT_SUCCESS(response))
  } catch (error) {
    yield put(UPDATE_UNIT_FAIL())
    console.log(error)
  }
}

export default function* UpdateUnitSaga(): Generator<any, void, any> {
  yield takeLatest([UPDATE_UNIT], UpdateUnitFlow)
}
